import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'

import {
  Box,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from '@mui/material'

import useTranslations from '../../../i18n/useTranslations'
import { ReactComponent as FilePdf } from '../../../assets/icons/file-pdf.svg'
import { ReactComponent as FileExcel } from '../../../assets/icons/file-excel.svg'

import EnhancedTableHead from '../../ShippingsOverview/EnhancedTableHead'
import EnhancedTableToolbar from '../../ShippingsOverview/EnhancedTableToolbar'

import { FILE_TYPES_MAP } from './useDownloadFile'

export const invoicePropType = PropTypes.shape({
  date: PropTypes.instanceOf(Date),
  id: PropTypes.string.isRequired,
  clientCode: PropTypes.string,
  amount: PropTypes.number,
  hasPdf: PropTypes.bool,
  hasXls: PropTypes.bool,
})

const propTypes = {
  selectInvoices: PropTypes.func.isRequired,
  downloadFile: PropTypes.func.isRequired,
  tableHeadsCells: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      sortable: PropTypes.bool,
    }),
  ),
  tableParams: PropTypes.shape({
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
    totalRows: PropTypes.number,
    sortType: PropTypes.string,
    sortColumn: PropTypes.string,
  }),
  invoices: PropTypes.arrayOf(invoicePropType).isRequired,
  rowsPerPageOptions: PropTypes.arrayOf(PropTypes.string),
}

const TableView = ({
  downloadFile,
  invoices,
  tableHeadsCells,
  rowsPerPageOptions = [10, 25, 50],
  selectInvoices,
}) => {
  const formatMessage = useTranslations()

  const [, setSelectedInvoices] = useState([])

  useEffect(() => {
    setSelectedInvoices([])
  }, [invoices])

  return (
    <>
      <TableContainer
        sx={{
          /* TODO: @maq - Implementar este estilo de una manera más coherente. */
          marginTop: 4,
        }}
      >
        <Table>
          <EnhancedTableHead
            headCells={tableHeadsCells}
            // numSelected={selectedRows.length}
            order="desc"
            orderBy="shippingDate"
            showIcon={false}
            showMenu={true}
            // onSelectAllClick={handleSelectAllClick}
            // onRequestSort={handleRequestSort}
            rowCount={invoices.length}
          />
          <TableBody>
            {invoices.map(invoice => (
              <TableRow key={invoice.id} hover>
                <TableCell>{invoice.date}</TableCell>
                <TableCell>{invoice.id}</TableCell>
                <TableCell>{invoice.clientCode}</TableCell>
                <TableCell>{invoice.amount}</TableCell>
                <TableCell classes={{ root: 'icon' }}>
                  {invoice.hasPdf ? (
                    <IconButton
                      aria-label="expand"
                      onClick={() => {
                        downloadFile(invoice.uid, FILE_TYPES_MAP.pdf)
                      }}
                    >
                      <FilePdf />
                    </IconButton>
                  ) : null}
                </TableCell>
                <TableCell classes={{ root: 'icon' }}>
                  {invoice.hasXls ? (
                    <IconButton
                      aria-label="expand"
                      onClick={() => {
                        downloadFile(invoice.uid, FILE_TYPES_MAP.xls)
                      }}
                    >
                      <FileExcel />
                    </IconButton>
                  ) : null}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        mb={2}
        py={2}
        px={1}
      >
        <EnhancedTableToolbar
          numTotal={invoices.length}
          numTotalText={formatMessage('noun:invoices')}
          numSelected={invoices.length}
        />
        {/* TODO: cuando se implemente la paginación en el endpoint que
            devuelve las facturas, volver a utilizar la paginación de la tabla
            e implementar la lógica. */}
        {/*<TablePagination
          component="div"
          rowsPerPageOptions={rowsPerPageOptions}
          labelRowsPerPage={formatMessage('noun:shipments-per-page')}
          // labelDisplayedRows={showLabelDisplayedRows}
          count="96"
          rowsPerPage="10"
          page="0"
          onPageChange={() => {}}
          onRowsPerPageChange={() => {}}
        />*/}
      </Box>
    </>
  )
}

TableView.propTypes = propTypes

export default TableView
